import React, { Component } from "react";
import { StatusFormContainer } from "../containers";
import { Header } from "../components/header";
export class StatusForm extends Component {
  constructor(props) {
    super();
  }

  render() {
    return (
      <div>
        <Header />
        <div className="container">
          <StatusFormContainer deviceSerial={this.props.match.params.deviceSerial} />
        </div>
      </div>
    );
  }
}
